/**
 * Brand Zone (Brand Hub) API Endpoints
 * Sidebar route: brand_zone
 */

export const BRAND_ZONE_ENDPOINTS = {
  types: 'brand-hub/get-brand-hub-types',
  list: 'brand-hub/get-brand-hubs',
  create: 'brand-hub/create-brand-hub',
  update: 'brand-hub/update-brand-hub',
  delete: 'brand-hub/delete-brand-hub',
  whitelistUpload: 'brand-hub/brand-hubwhitelist',
  whitelistUsers: 'brand-hub/list-brand-hub-whitelist-users',
  disableUser: 'brand-hub/disable-brand-hub-user',
} as const;
